import React, {useState} from "react";
import useEditableTableTextCell from "../../../hooks/useEditableTableTextCell";
import useEditableTableTextAreaCell from "../../../hooks/useEditableTableTextAreaCell";
import {Button, Form} from "react-bulma-components";
import TaxTypePicker from "./TaxTypePicker";


export default function NominalCodeRow({code, onChange, onSave, onDelete, index}){
    const [editable, setEditable] = useState(false);

    const handleSave = data => {
        onSave(data);
        setEditable(false);
    }


    return (
        <tr key={code.id}>
            {useEditableTableTextCell({
                propName: "name",
                value: code.name,
                editable: false,
                inlineEdit: false
            })}
            {useEditableTableTextCell({
                propName: "code",
                value: code.code,
                editable: false,
                inlineEdit: false
            })}
            {useEditableTableTextCell({
                propName: "type",
                value: code.type,
                editable: false,
                inlineEdit: false
            })}
            <td>
                <TaxTypePicker
                    value={code.tax_type}
                    disabled={true}
                />
            </td>
            {useEditableTableTextCell({
                propName: "bank_account_number",
                value: code.bank_account_number,
                editable: false,
                inlineEdit: false
            })}
            {useEditableTableTextAreaCell({
                propName: "description",
                value: code.description,
                editable : false,
                inlineEdit: false
            })}
            <td>
                <Form.Checkbox
                    checked={code.enable_payments_to_account}
                    disabled={true}
                />
            </td>
            <td>
                <Form.Checkbox
                    checked={code.show_in_expense_claims}
                    disabled={true}
                />
            </td>
        </tr>
    )



}